<!-- <div (click)="cerrar.emit()" *ngIf="svg" [innerHtml]="svg | safeHtml"></div> -->
<svg-icon (click)="cerrar.emit()" src="assets/imgs/fancy/cerrar.svg"></svg-icon>